export default {
  50: '#e3f6fd',
  100: '#cceffc',
  200: '#99dff9',
  300: '#7fd6f7',
  400: '#66cef5',
  500: '#33bef2',
  600: '#00aeef',
  700: '#00a7ed',
  800: '#009deb',
  900: '#0094e8',
  1000: '#0084e4',
  A50: '#0B79D0',
  A100: '#003448',
  A200: '#004359',
  A400: '#001E2E',
  A500: '#014F6C',
  contrastDefaultColor: 'light',
}
